import React, {useContext} from 'react';
import {getKda} from "../../function";
import styled from "styled-components";
import {ColumnBox} from "../ui/styled";
import {SllMatchContext} from "./sllMatchContext";

const KDAText = styled.p`
  line-height: 15px; /* 100% */
  margin-bottom: 2px;
  z-index: 2;
  color: #EEEEEE;

  span {
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
  }

  .slash {
    color: #EEEEEE;
    margin: 0 3px;
  }

`;

const KDAResultBox = styled.p`
  z-index: 2;
`;

const KDASpan = styled.span`
  font-size: 12px;
  line-height: 12px;
  color: #000;
  opacity: 0.5;
`;
const SllKda = () => {
    const { myMatch,data} = useContext(SllMatchContext);

    return (
        <ColumnBox height={'54px'} justifyContent={'center'} alignItems={'center'} margin={'0 0 0 10px'}>
            <KDAText className="type2">
                <span>{data?.kills}</span>
                <span className={'slash'}>
                                       /
                </span>
                <span>{data?.deaths}</span>
                <span className={'slash'}>
                                       /
                                   </span>
                <span>{data?.assists}</span>
            </KDAText>
            <KDAResultBox className="type3">
                {data?.deaths === 0 ? (
                    <KDASpan>Perfect</KDASpan>) : (
                    <KDASpan>{getKda(data?.kills, data?.deaths,data?.assists).toFixed(2)} KDA</KDASpan>
                )}
            </KDAResultBox>
        </ColumnBox>
    );
};

export default SllKda;